export function battle() {
  // PizzaKing has no deployed WebSocket gateway; battle pages use local read polling.
  return "";
}
export function openBox() {
  // Keep legacy callers offline until a PizzaKing WebSocket gateway is configured.
  return "";
}
